import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000, // 1 minute — prevents unnecessary refetches on mount/focus
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
